(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["viora-global-cart-data-bridge"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.VioraGlobalCartDataBridgeFastV4) return;
    window.VioraGlobalCartDataBridgeFastV4 = true;

    var itemsObserver = null;
    var observedItemsNode = null;
    var renderScheduled = false;
    var previewScheduled = false;
    var latestEventCart = null;
    var handledEvents = new WeakSet();
    var statusObserver = null;
    var observedStatusNode = null;

    function normalizeStatusText(value) {
      return String(value == null ? '' : value)
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase();
    }

    function isTransientStatusText(value) {
      var text = normalizeStatusText(value);
      if (!text) return false;

      return (
        text.indexOf('updating your cart') !== -1 ||
        text.indexOf('updating cart') !== -1 ||
        text.indexOf('refreshing your cart') !== -1 ||
        text.indexOf('adding to your viora box') !== -1 ||
        text.indexOf('adding to cart') !== -1 ||
        text.indexOf('adding item') !== -1 ||
        text.indexOf('removing from your cart') !== -1 ||
        text.indexOf('removing from cart') !== -1 ||
        text.indexOf('saving your free jar') !== -1 ||
        text.indexOf('saving your cart') !== -1 ||
        text.indexOf('updating free jar') !== -1 ||
        text === 'please wait...' ||
        text === 'please wait…'
      );
    }

    function syncStatusVisibility() {
      var root = document.getElementById('viora-global-cart');
      var status = root ? root.querySelector('[data-vgc-status]') : null;
      if (!status) return;

      status.classList.toggle(
        'viora-vgc-status--transient',
        isTransientStatusText(status.textContent || '')
      );
    }

    function connectStatusObserver() {
      var root = document.getElementById('viora-global-cart');
      var status = root ? root.querySelector('[data-vgc-status]') : null;

      if (!status) {
        if (statusObserver) statusObserver.disconnect();
        statusObserver = null;
        observedStatusNode = null;
        return false;
      }

      if (status === observedStatusNode) {
        syncStatusVisibility();
        return true;
      }

      if (statusObserver) statusObserver.disconnect();
      observedStatusNode = status;
      statusObserver = new MutationObserver(syncStatusVisibility);
      statusObserver.observe(status, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['hidden']
      });
      syncStatusVisibility();
      return true;
    }

    function giftSources() {
      return Array.prototype.slice.call(
        document.querySelectorAll('[data-viora-gift-option]')
      );
    }

    function giftSourceByVariant(variantId, sources) {
      var normalizedId = String(variantId || '');

      return sources.find(function (source) {
        return String(source.getAttribute('data-variant-id') || '') === normalizedId;
      }) || null;
    }

    function updateGiftPreview(slot, sources) {
      if (!slot) return;

      var label = slot.querySelector('.vgc__gift-slot-label');
      var select = slot.querySelector('[data-vgc-gift-select]');
      if (!label || !select || !sources.length) return;

      var source = giftSourceByVariant(select.value, sources) || sources[0];
      var image = source ? String(source.getAttribute('data-image') || '') : '';
      var title = source ? String(source.getAttribute('data-title') || 'Free jar') : 'Free jar';

      if (!image) return;

      var preview = label.querySelector('.vgc__gift-preview-image');
      if (!preview) {
        label.textContent = '';
        preview = document.createElement('img');
        preview.className = 'vgc__gift-preview-image';
        preview.loading = 'eager';
        preview.decoding = 'async';
        label.appendChild(preview);
      }

      if (preview.getAttribute('src') !== image) preview.setAttribute('src', image);
      preview.setAttribute('alt', title + ' free jar');
    }

    function updateAllGiftPreviews() {
      var sources = giftSources();
      if (!sources.length) return;

      document.querySelectorAll('[data-vgc-gift-slot]').forEach(function (slot) {
        updateGiftPreview(slot, sources);
      });
    }

    function connectItemsObserver() {
      var root = document.getElementById('viora-global-cart');
      var itemsNode = root ? root.querySelector('[data-vgc-items]') : null;

      if (!itemsNode || itemsNode === observedItemsNode) return !!itemsNode;

      if (itemsObserver) itemsObserver.disconnect();
      observedItemsNode = itemsNode;
      itemsObserver = new MutationObserver(function () {
        schedulePreviewOnly();
      });
      itemsObserver.observe(itemsNode, { childList: true, subtree: true });
      return true;
    }

    function schedulePreviewOnly() {
      if (previewScheduled) return;
      previewScheduled = true;

      window.requestAnimationFrame(function () {
        previewScheduled = false;
        connectItemsObserver();
        connectStatusObserver();
        updateAllGiftPreviews();
        syncStatusVisibility();
      });
    }

    function refreshController(cart) {
      var controller = window.VioraGlobalCart;

      if (!controller || typeof controller.refresh !== 'function') {
        schedulePreviewOnly();
        return Promise.resolve(null);
      }

      return Promise.resolve(controller.refresh(cart || undefined))
        .catch(function (error) {
          console.error('Unable to refresh the Viora global cart:', error);
          return null;
        })
        .then(function (result) {
          schedulePreviewOnly();
          return result;
        });
    }

    function scheduleRefresh(cart) {
      if (cart && Array.isArray(cart.items)) latestEventCart = cart;
      if (renderScheduled) return;

      renderScheduled = true;
      window.requestAnimationFrame(function () {
        renderScheduled = false;
        var nextCart = latestEventCart;
        latestEventCart = null;
        refreshController(nextCart);
      });
    }

    function sourceAlreadyRendered(source) {
      source = String(source || '').toLowerCase();

      return (
        source === 'viora-global-cart' ||
        source === 'viora-free-jar-v6' ||
        source === 'viora-free-jar-fast' ||
        source === 'viora-free-jar-v7' ||
        source === 'viora-global-cart-data-bridge'
      );
    }

    function receiveCartEvent(event) {
      if (event && handledEvents.has(event)) return;
      if (event) handledEvents.add(event);

      var detail = event && event.detail ? event.detail : {};

      /*
        Critical performance fix:
        VioraGlobalCart/changeItem already renders the returned cart before it
        dispatches cart:updated. Refreshing again here caused the second redraw.
      */
      if (
        sourceAlreadyRendered(detail.source) ||
        (event && event.type === 'viora:cart:open')
      ) {
        schedulePreviewOnly();
        return;
      }

      scheduleRefresh(detail.cart || null);
    }

    [
      'cart:updated',
      'cart:refresh',
      'cart:update',
      'cart:change',
      'theme:cart:updated',
      'product:added',
      'viora:cart:open'
    ].forEach(function (eventName) {
      document.addEventListener(eventName, receiveCartEvent);
      window.addEventListener(eventName, receiveCartEvent);
    });

    document.addEventListener('change', function (event) {
      var target = event.target instanceof Element ? event.target : null;
      var select = target ? target.closest('[data-vgc-gift-select]') : null;
      if (!select) return;

      updateGiftPreview(select.closest('[data-vgc-gift-slot]'), giftSources());
    });

    /*
      Preserve the SAFE V3 startup behavior that your working store depended on.
      We intentionally do not use the older aggressive "lazy only" startup.
    */
    var attempts = 0;
    (function boot() {
      attempts += 1;
      connectItemsObserver();
      connectStatusObserver();
      updateAllGiftPreviews();
      syncStatusVisibility();

      if (window.VioraGlobalCart && typeof window.VioraGlobalCart.refresh === 'function') {
        refreshController(null);
        return;
      }

      if (attempts < 50) window.setTimeout(boot, 200);
    })();

    document.addEventListener('shopify:section:load', function () {
      observedItemsNode = null;
      observedStatusNode = null;
      connectItemsObserver();
      connectStatusObserver();
      syncStatusVisibility();
      scheduleRefresh(null);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
